class Lottie {
	constructor() {
		this.items = $('[data-load-svg-animation]');
		this.items.each(function (index, elem) {
			setTimeout(() => {
				lottie.loadAnimation({
					container: elem,
					renderer: 'svg',
					loop: false,
					autoplay: true,
					path: $(this).attr('data-load-svg-animation'),
					name: $(this).attr('data-lottie-name'),
				});
			}, 600);
		});
	}
}